import * as React from 'react';
import Snackbar, { SnackbarCloseReason, SnackbarOrigin } from '@mui/material/Snackbar';
import Alert, { AlertProps } from '@mui/material/Alert';

export const SnackbarLocal = ({ duration, severity, message, open, setOpen }:
    {
        duration: number,
        severity: AlertProps['severity'],
        message: string,
        open: boolean,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    }) => {

    const handleClose = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return <div>
        <Snackbar open={open} autoHideDuration={duration} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert
                onClose={handleClose}
                severity={severity}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {message}
            </Alert>
        </Snackbar>
    </div>
}

export default SnackbarLocal;